export function ProductDetailIcon() {
  return (
    <svg fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.0003 23.8327C18.9834 23.8327 23.8337 18.9824 23.8337 12.9993C23.8337 7.01626 18.9834 2.16602 13.0003 2.16602C7.01724 2.16602 2.16699 7.01626 2.16699 12.9993C2.16699 18.9824 7.01724 23.8327 13.0003 23.8327Z"
        stroke="#1C274C"
        strokeWidth="1.5"
      />
      <path d="M13 18.416V11.916" stroke="#1C274C" strokeLinecap="round" strokeWidth="1.5" />
      <path
        d="M13.0003 7.58333C13.5986 7.58333 14.0837 8.06836 14.0837 8.66667C14.0837 9.26498 13.5986 9.75 13.0003 9.75C12.402 9.75 11.917 9.26498 11.917 8.66667C11.917 8.06836 12.402 7.58333 13.0003 7.58333Z"
        fill="#1C274C"
      />
    </svg>
  )
}
